export type ArcturianAvatarVariant = 'midshot' | 'fullbody'

export const ARCTURIAN_AVATAR_VARIANT_STORAGE_KEY = 'arcturian.avatarVariant'
export const DEFAULT_ARCTURIAN_AVATAR_VARIANT: ArcturianAvatarVariant = 'midshot'
export const ARCTURIAN_AVATAR_PACKAGE_CONTRACT_REVISION = '2026-08-03.2'

/**
 * Package boundary for Web presentation. A package owns its complete manifest,
 * poster and renderer family; selecting one must never borrow media from the
 * other package while it warms up.
 */
export const ARCTURIAN_WEB_AVATAR_PACKAGES = {
  midshot: {
    package_id: 'arcturian.dr-peter-tschauko.midshot',
    variant_id: 'midshot',
    manifest_url: '/arcturian/avatar-manifest.v1.json',
    renderer: 'opaque-video',
  },
  fullbody: {
    package_id: 'arcturian.dr-peter-tschauko.fullbody',
    variant_id: 'fullbody',
    manifest_url: '/arcturian/avatar-manifest.fullbody.v2.json',
    renderer: 'green-canvas',
  },
} as const satisfies Record<ArcturianAvatarVariant, {
  package_id: string
  variant_id: ArcturianAvatarVariant
  manifest_url: string
  renderer: 'opaque-video' | 'green-canvas'
}>

export function arcturianWebAvatarPackage(variant: ArcturianAvatarVariant) {
  return ARCTURIAN_WEB_AVATAR_PACKAGES[variant]
}

export function isArcturianAvatarVariant(value: string | null | undefined): value is ArcturianAvatarVariant {
  return value === 'midshot' || value === 'fullbody'
}

/** Query selection is shareable and wins; persisted selection is the fallback. */
export function resolveArcturianAvatarVariant(
  search: string,
  storedValue: string | null,
): ArcturianAvatarVariant {
  const queryValue = new URLSearchParams(search).get('avatar')
  if (isArcturianAvatarVariant(queryValue)) return queryValue
  if (isArcturianAvatarVariant(storedValue)) return storedValue
  return DEFAULT_ARCTURIAN_AVATAR_VARIANT
}

export function persistArcturianAvatarVariant(variant: ArcturianAvatarVariant): void {
  try {
    window.localStorage.setItem(ARCTURIAN_AVATAR_VARIANT_STORAGE_KEY, variant)
    const url = new URL(window.location.href)
    url.searchParams.set('avatar', variant)
    window.history.replaceState(window.history.state, '', url)
  } catch {
    // Storage and history can be disabled in privacy-constrained WebViews.
  }
}
